import { Base64 } from 'js-base64'
import _ from 'lodash'
import slugify from 'slugify'
import { OutOfStockStatusEnum } from '../../generated/gqlTypes'

export const getDBIdFromGraphqlId = (graphqlId, schema) => {
  // This is temporary solution, we will use slugs in the future
  const rawId = Base64.decode(graphqlId)
  const regexp = /(\w+):(\d+)/
  const arr = regexp.exec(rawId)
  if (schema && schema !== arr[1]) {
    throw new Error('Schema is not correct')
  }
  return parseInt(arr[2], 10)
}

export const getGraphqlIdFromDBId = (id, schema) =>
  // This is temporary solution, we will use slugs in the future
  Base64.encode(`${schema}:${id}`)

export const getSlug = (str): string => {
  return slugify(str, { lower: true, remove: /[*+~.,()'"!:@?]/g })
}

export const onlyUnique = (value, index, self) => {
  return self.indexOf(value) === index
}

export const matchVariantFromSelection = (attrs, variants) => {
  let matchedVariant = null
  if (variants) {
    const index = _.findIndex(variants, (o: any) => {
      const variantAttributes = {}
      o.properties?.forEach(prop => {
        variantAttributes[prop.attributeName] = prop.valueName
      })
      return _.isEqual(variantAttributes, attrs)
    })
    if (index > -1) {
      matchedVariant = variants[index]
    }
  }
  return matchedVariant
}

export const checkVariantAvailability = (selectedVariant: {
  stockStatus: OutOfStockStatusEnum | null
  shippingRequired: boolean
  outOfStockStatus: string
  stockQuantity: number
}) => {
  if (!selectedVariant || selectedVariant.stockStatus === OutOfStockStatusEnum.Out) {
    return false
  }
  return (
    !selectedVariant.shippingRequired || selectedVariant.outOfStockStatus !== 'OUT' || selectedVariant.stockQuantity > 0
  )
}

export const getReviewRatingValue = (score: number) => {
  if (score === 1) return 5
  else if (score === 0) return 3
  return 1
}

export const isTablet = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase()
  return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
    userAgent
  )
}

export const upperFirstLetter = (text: string) => {
  if (!text) return ''
  if (text.length === 1) return text.toUpperCase()
  return text[0].toUpperCase() + text.slice(1)
}

export function countryToFlag(isoCode: string) {
  return typeof String.fromCodePoint !== 'undefined'
    ? isoCode
        .toString()
        .toUpperCase()
        .replace(/./g, char => String.fromCodePoint(char.charCodeAt(0) + 127397))
    : isoCode
}

export function camelize(str: string): string {
  return str
    .replace('_', ' ')
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase()
    })
    .replace(/\s+/g, '')
}

export const maybe = <T = any>(func, defaultValue: T): T => {
  try {
    return func() as T
  } catch (e) {
    return defaultValue
  }
}

export function scrollToTop() {
  try {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' })
  } catch (e) {
    console.error(e.message)
  }
}

export function scrollIntoView(elementId: string, arg?: boolean | ScrollIntoViewOptions) {
  const element = document.getElementById(elementId)
  try {
    element.scrollIntoView(arg)
  } catch (e) {
    element.scrollIntoView(true)
  }
}

export const getYoutubeThumb = (url: string | null, quality = 'hq') => {
  if (!url || typeof url !== 'string') return null

  // Підтримка всіх основних форматів
  const regExp = /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/))([\w-]{11})/
  const match = url.match(regExp)

  if (!match) return null

  const id = match[1]
  const q = quality === 'max' ? 'maxresdefault' : `${quality}default`

  return `https://img.youtube.com/vi/${id}/${q}.jpg`
}

export const hideUsername = (username: string): string => {
  if (username && !!username.trim()) {
    const splitStr = username.trim().split(' ')
    if (splitStr.length < 2) {
      return username
    } else {
      if (splitStr.length === 2) {
        const name = splitStr[0]
        let last_name = splitStr[1]
        last_name = last_name.slice(0, Math.floor(last_name.length / 2)) + '***' + last_name.slice(-1)
        return `${name} ${last_name}`
      }
      const result = splitStr.slice(0, -1).join(' ')
      const last = splitStr.slice(-1)
      return result + last.slice(0, Math.floor(last.length / 2)) + '***' + last.slice(-1)
    }
  }
  return username
}

export const decodeHtml = (str: string) => {
  const txt = document.createElement('div')
  txt.innerHTML = str
  return txt.textContent || ''
}

export const getCurrencySymbol = (currency: string) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
  })
    .formatToParts(1)
    .find(p => p.type === 'currency').value
}
